import { structureSearchService } from '@/services/structure-search.service';
import { useMutation } from '@tanstack/react-query';

export const useStructureToNumber = () => {
  return useMutation((parameter: { exactSearch: 'true' | 'false'; mrv: string }) => {
    return structureSearchService.structureToNumber(parameter);
  });
};

export const useStructureSearch = () => {
  return useMutation(
    (parameter: {
      language: string;
      country: string;
      casNumberList: string;
      pageNo: number;
      pageSize: number;
      filter?: string;
      gpt?: string;
      sortOrder: 'asc' | 'desc';
    }) => {
      return structureSearchService.structureSearch(parameter);
    }
  );
};
